export default "__VITE_ASSET__6NwZv3ki__"